<script>
    import debounce from "lodash/debounce";

    import { fly } from "svelte/transition";

    import { systemFonts } from "../PortalCustomisationConstants.svelte";

    import { SEARCH } from "../../../Utils/utilConstants.svelte";

    export let fontFamilyConfig = {};

    const handleDebouncedChange = debounce((e) => {
        fontFamilyConfig.fontUrl = e.target.value;
    }, SEARCH.DEBOUNCE_TIME);

    const collapse = (node, args) => fly(node, args);
</script>

<div class="flex flex-col gap-y-2">
    <div class="flex w-full items-center gap-x-2">
        <p class="w-[20%]">Font Family</p>

        <div class="flex w-full items-center justify-between">
            <select
                class="input input-sm input-bordered"
                bind:value={fontFamilyConfig.systemFont}
                disabled={fontFamilyConfig.usingURLFont}
                on:change={() => {
                    const selectedFont = systemFonts.find(
                        (font) => font.name == fontFamilyConfig.systemFont,
                    );

                    if (selectedFont)
                        fontFamilyConfig.fontUrl = selectedFont.url ?? "";
                }}
            >
                {#each systemFonts as { name }}
                    <option
                        value={name}
                        selected={fontFamilyConfig?.systemFont == name}
                    >
                        {name}
                    </option>
                {/each}
            </select>

            <div class="flex items-center gap-x-1">
                <input
                    type="checkbox"
                    id="useFontURLCheckbox"
                    class="toggle toggle-secondary"
                    bind:checked={fontFamilyConfig.usingURLFont}
                />
                <label for="useFontURLCheckbox" class="cursor-pointer">
                    Use a Google Font
                </label>
            </div>
        </div>
    </div>

    {#if fontFamilyConfig?.usingURLFont}
        <div
            class="flex w-full items-center gap-x-2"
            in:collapse={{ duration: 200, y: -50 }}
        >
            <p class="w-[20%]">Google Font URL</p>
            <input
                type="url"
                class="input input-sm input-bordered w-full"
                placeholder="Copy and Paste your preferred Google font url here"
                on:input={handleDebouncedChange}
                value={fontFamilyConfig?.fontUrl}
            />
        </div>
    {/if}
</div>
